var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "candidate-modal-changes-history" },
    [
      !_vm.loadingCandidateInfo &&
      _vm.candidateInfo &&
      _vm.candidateInfo.history
        ? _c("scrolled-table", [
            _c("table", { staticClass: "h-table" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", [_vm._v("Изменено")]),
                  _c("th", [_vm._v("История кандидата")]),
                  _c("th", [_vm._v("Комментарий")]),
                ]),
              ]),
              _c(
                "tbody",
                _vm._l(
                  _vm.candidateInfo.history,
                  function (record, recordIndex) {
                    return _c("tr", { key: recordIndex }, [
                      _c("td", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "candidate-modal-changes-history__date-cell",
                          },
                          [_vm._v(_vm._s(record.time))]
                        ),
                      ]),
                      _c("td", [_vm._v(_vm._s(record.description))]),
                      _c("td", [
                        _vm._v(_vm._s(record.comment ? record.comment : "—")),
                      ]),
                    ])
                  }
                ),
                0
              ),
            ]),
          ])
        : _vm._e(),
      _vm.loadingCandidateInfo
        ? _c("c-loader", {
            attrs: { active: true, height: "300", label: "Загрузка данных" },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }